// POS-0034 Stage 3: country selector for phone entry. Drives the `region` sent to the backend's
// approved normalizer (/customers/phone/validate) — this list is for the selector UI only; the
// actual validation/canonical-formatting decision always comes from the backend, never from here.
export const COUNTRIES = [
  { code: "JM", label: "Jamaica", dial: "+1 876 / 658", flag: "🇯🇲" },
  { code: "US", label: "United States", dial: "+1", flag: "🇺🇸" },
  { code: "CA", label: "Canada", dial: "+1", flag: "🇨🇦" },
  { code: "GB", label: "United Kingdom", dial: "+44", flag: "🇬🇧" },
  { code: "TT", label: "Trinidad & Tobago", dial: "+1 868", flag: "🇹🇹" },
  { code: "BB", label: "Barbados", dial: "+1 246", flag: "🇧🇧" },
  { code: "BS", label: "Bahamas", dial: "+1 242", flag: "🇧🇸" },
  { code: "KY", label: "Cayman Islands", dial: "+1 345", flag: "🇰🇾" },
  { code: "GY", label: "Guyana", dial: "+592", flag: "🇬🇾" },
  { code: "CN", label: "China", dial: "+86", flag: "🇨🇳" },
  { code: "IN", label: "India", dial: "+91", flag: "🇮🇳" },
  { code: "NG", label: "Nigeria", dial: "+234", flag: "🇳🇬" },
];

export const DEFAULT_COUNTRY = "JM";
